import axios from "axios";

export async function carregarRelatorio({ inicio, fim }) {
  const { data } = await axios.get("/api/campaigns/cross-sell/report", {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    params: { date_from: inicio, date_to: fim },
  });
  return data;
}
